module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Sweet.60164649.jpg";